import React, { useState, useEffect, Suspense } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import HomeFooterComponent from "./Common/Footer";
import TailwindNavbar from "../components/Navbar";
import CoachSideMenuComponent from "../Coach/Common/Sidemenu";
import { useSidebar } from "../utils/context/SidebarContext";
import { useBanner } from "../utils/context/BannerContext";

function HomeLayoutComponent(props) {
  const [scroll, setScroll] = useState(false);
  const [isShowMenues, setisShowMenues] = useState(false);
  const { sidebarOpen, isMobileView, closeSidebar, toggleSidebar } = useSidebar();
  const { isBannerVisible } = useBanner();

  const location = useLocation();
  const path = location.pathname;
  const pathSegments = path.split("/");
  const pathFirstName = pathSegments[1];
  const { id, token } = useParams();

  // Dynamic margins based on banner visibility
  const fullPageMargin = isBannerVisible ? "mt-[92px]" : "mt-[63px]";
  const coachDetailsMargin = isBannerVisible ? "mt-[92px]" : "mt-[63px]";
  const sidebarTop = isBannerVisible ? "top-[92px]" : "top-[63px]";
  const sidebarHeight = isBannerVisible ? "h-[calc(100vh-92px)]" : "h-[calc(100vh-63px)]";
  const sidebarPadding = isBannerVisible ? "pt-[92px]" : "pt-[63px]";
  const contentPadding = isBannerVisible ? "pt-[92px]" : "pt-[63px]";

  useEffect(() => {
    const handleScroll = () => setScroll(window.scrollY > 0);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const onClickToggle = () => {
    setisShowMenues(!isShowMenues);
  };

  const isFullPage =
    path === "/" ||
    path === "/login" ||
    path === "/signup" ||
    path === "/about" ||
    path === "/browse-coach/list-view" ||
    path === "/browse-coach/grid-view" ||
    path === "/become-a-coach" ||
    path === "/privacy-policy" ||
    path.startsWith("/browse-coach/coach-details/") ||
    path === `/updatepassword/${token}` ||
    path === "/terms-of-services" ||
    path === "/forgot-password" ||
    path === "/contact" ||
    path === "/CookiePolicy" ||
    path === "/blogs" ||
    path === "/CoachAgreement" ||
    path === "/refund-policy" ||
    path === "/email-verification" ||
    path === "/CommunityGuidelines" ||
    path === "/activity-stream" ||
    pathFirstName === "blog-details";

  return (
    <>
      <TailwindNavbar 
        sidebarOpen={sidebarOpen}
        onToggleSidebar={toggleSidebar}
        isMobileView={isMobileView}
      />
      <div className="min-h-screen">
        {isFullPage ? (
          <div
            className={
              path.startsWith("/browse-coach/coach-details/")
                ? coachDetailsMargin
                : fullPageMargin
            }
          >
            <Suspense fallback={<div />}>
              <Outlet />
            </Suspense>
          </div>
        ) : (
          <div className="container flex justify-between mb-8">
            {/* Backdrop for mobile sidebar overlay */}
            {isMobileView && sidebarOpen && (
              <div
                className={`fixed inset-0 ${sidebarTop} bg-black/50 z-40 transition-opacity duration-300`}
                onClick={closeSidebar}
                aria-label="Close sidebar"
              />
            )}

            {/* Sidebar - hidden on mobile unless open */}
            <div className={`${
              isMobileView
                ? `fixed left-0 ${sidebarTop} ${sidebarHeight} z-50 w-[200px] transition-all duration-300 ${
                    sidebarOpen ? 'translate-x-0' : '-translate-x-full'
                  }`
                : `${sidebarPadding} transition-all duration-300 w-[200px]`
            }`}>
              <CoachSideMenuComponent 
                isOpen={sidebarOpen}
                onClose={closeSidebar}
                isMobileView={isMobileView}
              />
            </div>

            {/* Main content area */}
            <div className="container flex justify-between mb-8">
              <div className={`${contentPadding} w-full`}>
                <Suspense fallback={<div />}>
                  <Outlet />
                </Suspense>
              </div>
            </div>
          </div>
        )}
      </div>

      <HomeFooterComponent />
    </>
  );
}

export default HomeLayoutComponent;
